import React from "react";
import TextImageBanner from "../../components/common/TextImageBanner";
import CareerCard from "../../components/UserComponents/career/CareerCard";
import image from"../../Assets/Home/MainHome/home3.png";
const Career = () => {
  return (
    <div className="bg-[#fafafa]">
      <TextImageBanner
        label="Career"
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]}
      />
      <CareerCard />
    </div>
  );
};

export default Career;
